<div mat-dialog class="dialog-backdrop">
    <h1 mat-dialog-title>Change Date</h1>
    <div class="modal-contents" [formGroup]="forms">
        <span *ngIf="field === 'pickup' && shipper_timezone">Local time zone is {{shipper_timezone}}</span>
        <span *ngIf="(field === 'delivery' || field === 'appointment') && consignee_timezone">Local time zone is {{consignee_timezone}}</span>

        <mat-form-field *ngIf="field === 'pickup'">
            <mat-label>Pickup Date</mat-label>
            <input matInput [matDatepicker]="pickup_datepicker" formControlName="pickup_date"/>
            <mat-datepicker-toggle matIconSuffix [for]="pickup_datepicker"></mat-datepicker-toggle>
            <mat-datepicker #pickup_datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="field === 'delivery'">
            <mat-label>Delivery Date</mat-label>
            <input matInput [matDatepicker]="delivery_datepicker" formControlName="delivery_date"/>
            <mat-datepicker-toggle matIconSuffix [for]="delivery_datepicker"></mat-datepicker-toggle>
            <mat-datepicker #delivery_datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
            </mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="field === 'appointment'">
            <mat-label>Appointment Date</mat-label>
            <input matInput [matDatepicker]="appointment_datepicker" formControlName="appointment_date"/>
            <mat-datepicker-toggle matIconSuffix [for]="appointment_datepicker"></mat-datepicker-toggle>
            <mat-datepicker #appointment_datepicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                </mat-datepicker-actions>              
            </mat-datepicker>
        </mat-form-field>



        <mat-form-field *ngIf="field === 'pickup'">
            <mat-label>Local Time</mat-label>
            <input matInput type="time" formControlName="pickup_time"/>
        </mat-form-field>
        <mat-form-field *ngIf="field === 'delivery'">
            <mat-label>Local Time</mat-label>
            <input matInput type="time" formControlName="delivery_time"/>
        </mat-form-field>
        <mat-form-field *ngIf="field === 'appointment'">
            <mat-label>Start Time</mat-label>
            <input matInput type="time" formControlName="appointment_start"/>
        </mat-form-field>
        <mat-form-field *ngIf="field === 'appointment'">
            <mat-label>End Time</mat-label>
            <input matInput type="time" formControlName="appointment_end"/>
        </mat-form-field>
    </div>
    <mat-dialog-actions>
        <button mat-flat-button (click)="onCloseModal()" color="primary">Cancel</button>
        <button mat-flat-button (click)="onSubmit()" color="primary">Save</button>
    </mat-dialog-actions>
</div>
